import _ from 'underscore';
import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';
import { MAX_PREPAYMENTS } from '@/js/common/Constants/globalParams';

type Params = {
    firstPaymentDefinitionIds: number[];
    firstPaymentDefinitionReferenceIndex: {
        [key: number]: IFirstPaymentDefinition;
    };
}

export default (params: Params ): IFirstPaymentDefinition[] => {
    const { firstPaymentDefinitionIds, firstPaymentDefinitionReferenceIndex } = params;
    return _.map(firstPaymentDefinitionIds, (routeId) => firstPaymentDefinitionReferenceIndex[routeId])?.slice(0, MAX_PREPAYMENTS);
}